/**
 * @description
 */

import { fetchData } from '@umu/umu-fetch';

import Api from '../../../../path';

export interface IInput {
    practice_id: number;
    question_ids: string; // number[].join(',');
}

export interface IQuestionDesc {
    element_title: string;
    element_share_url: string;
    course_title: string;
    course_share_url: string;
}

export interface IOutput {
    [key: string]: IQuestionDesc;
}

export const getQuestionDesc = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.QUESTION_COLLECTION_GET_QUESTION_DESC, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
